import React from 'react';
import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react';
import { cn } from '../cn';
import { InfoTooltip } from './InfoTooltip';
import { deltaTone, formatDeltaPct } from './format';
import { toneStyle } from './tones';
const badgeToneClasses = {
    positive: 'bg-emerald-50 text-emerald-700',
    negative: 'bg-red-50 text-red-700',
    neutral: 'bg-gray-100 text-gray-600',
};
/** Flat 2D KPI card: label + icon chip, large value, delta badge. */
export const MetricCard = ({ label, value, tooltip, kpi, goodWhen = 'up', tone = 'slate', icon: Icon, hero = false, signAware = false, sub, loading, valueClassName, className, }) => {
    const styles = toneStyle(tone);
    const delta = kpi === null || kpi === void 0 ? void 0 : kpi.deltaPct;
    const badge = deltaTone(delta, goodWhen);
    const showDelta = kpi !== undefined && kpi !== null;
    const DeltaIcon = delta != null && delta > 0 ? ArrowUpRight : delta != null && delta < 0 ? ArrowDownRight : Minus;
    const signClass = signAware && kpi
        ? kpi.value > 0
            ? 'text-emerald-800'
            : kpi.value < 0
                ? 'text-rose-800'
                : 'text-gray-900'
        : null;
    const valueInk = valueClassName || signClass || (showDelta || hero ? styles.value : 'text-gray-900');
    return (React.createElement("div", { className: cn('flex h-full min-h-[76px] flex-col rounded-2xl border border-gray-200 p-3.5', hero ? styles.wash : styles.surface, className) },
        React.createElement("div", { className: "flex items-start justify-between gap-2" },
            React.createElement("div", { className: "flex min-w-0 items-center gap-1" },
                React.createElement("p", { className: "text-[11px] font-medium uppercase tracking-wide text-gray-500" }, label),
                React.createElement(InfoTooltip, { title: label, content: tooltip })),
            Icon ? (React.createElement("span", { className: cn('inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-lg', styles.chipBg, styles.chipText) },
                React.createElement(Icon, { size: 13, strokeWidth: 2, "aria-hidden": "true" }))) : null),
        React.createElement("div", { className: "mt-2 flex flex-wrap items-baseline gap-1.5" },
            React.createElement("p", { className: cn('font-semibold tabular-nums', hero ? 'text-lg' : 'text-base', valueInk) }, loading ? '…' : value),
            !loading && showDelta ? (React.createElement("span", { className: cn('inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-[11px] font-semibold tabular-nums', badgeToneClasses[badge]), title: "vs previous period of equal length" },
                React.createElement(DeltaIcon, { size: 12, "aria-hidden": "true" }),
                formatDeltaPct(delta))) : null),
        sub && !loading ? React.createElement("p", { className: "mt-1.5 text-xs text-gray-500" }, sub) : null));
};
export default MetricCard;
